$(document).ready(function () {
    // master
    $('[data-toggle="tooltip"]').tooltip();
    $('#navbarNavDropdown li a').each(function () {
        if ($(this).attr('href') === location.href) {
            $('#navbarNavDropdown li').removeClass('active');
            $(this).parent().addClass('active')
        }
    });
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    setInterval(function () {
        $('.nav-instagram').fadeOut(1000,function () {
            $('.nav-instagram').fadeIn(1000);
        });
    },500)
    // index
    if ($.fn.slick) {
    $('.index-page .slider-for').slick({
        dots: false,
        rtl: true,
        slidesToShow: 5,
        accessibility: false,
        draggable: false,
        centerMode:true,
        centerPadding: 0,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            }
        ]
    });
}
    $('.carousel .carousel-item a').click(function () {
        $.post('/api/slide/update/' + $(this).attr('id'),{_method:'PUT'},function (data) {});
    });
    $('.index-page .slider-row').removeClass('d-none');
    $('.index-page form#province button').click(function (e) {
        e.preventDefault();
        let form = $('.index-page form#province');
        let input = $('<input>', {
            type: 'hidden',
            name: 'province',
            value: $(this).text()
        });
        form.append(input);
        form.submit();
    });
    // categories
    (function ($) {
        $.fn.categories = function (cat, options) {
            let all_cat = [];
            $.each(cat, function (i, v) {
                if (v.parentId == 0)
                    all_cat.push(v);
            });
            let opts = $.extend({
                container: '.categories',
                borderBottom: '2px solid #D1D1D1'
            }, options);
            let container = $(opts.container);
            let isProduct = container.data('product');
            container.on("mouseenter", "li", function () {
                $(this).find('i').removeClass('d-none');
            });

            container.on("mouseleave", "li", function () {
                $(this).find('i').addClass('d-none');
            });
            container.on('click', 'li', function () {
                let _this = $(this);
                let p_elm = _this.parent();
                let title = _this.text();
                let isActive = _this.hasClass('active');
                let id = _this.attr('data-id');
                let p_id = _this.attr('data-parent');
                if (_this.hasClass('go')) {
                    window.location.href = (isProduct ? '/product/create?c_id=' : '/post/create?c_id=') + id;
                    return false;
                }
                p_elm.children().remove();
                $.each(cat, function (index, value) {
                    let start = false;
                    if (isActive) {
                        if (p_id == 0 || value.id == p_id) {
                            start = true;
                        }
                    } else {
                        if (value.id == id) {
                            start = true;
                        }
                    }
                    if (start) {
                        let data = [];
                        if (isActive && p_id == 0) data = all_cat;
                        else data = value.children;
                        if (data !== all_cat) {
                            let i = $('<i>').addClass('fa fa-chevron-right back mr-3');
                            let span = $('<span>').html(value.name);
                            $('<li>', {
                                'data-id': value.id,
                                'data-parent': value.parentId,
                                class: 'list-group-item d-flex align-items-center category py-3  active'
                            }).css({borderBottom: opts.borderBottom}).append(i).append(span).appendTo(p_elm);
                        }
                        $.each(data, function (i, v) {
                            let span = $('<span>').html(v.name);
                            let elm = $('<li>', {
                                class: 'list-group-item d-flex justify-content-between align-items-center py-3  category',
                                'data-id': v.id,
                                'data-parent': v.parentId

                            }).append(span).appendTo(p_elm);
                            if (v.nextPage) elm.append($('<i>', {class: 'fa fa-chevron-left d-none'}));
                            else elm.addClass('go').append($('<i>', {class: 'fa fa-check-square d-none'}));
                        });
                        return false;
                    }
                });
            });
        }
    })(jQuery);
    $('li').categories(window.categories);
    // posts
    $('.posts .card').hover(function () {
        $(this).toggleClass('shadow shadow-sm');
    }, function () {
        $(this).toggleClass('shadow shadow-sm');
    });
    $('.slider-adv .card .card-body a').click(function () {
        $.post('/api/slide/update/' + $(this).attr('id'),{_method:'PUT'},function (data) {});
    });
    $('.posts-page input[name=layout]').change(() => {
        $('form#layout').submit();
    });
    if ($.fn.slick) {
    $('.slider-reps .slider-for').slick({
        dots: false,
        rtl: true,
        slidesToShow: 5,
        accessibility: false,
        draggable: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
        ]
    });
        $('.slider-adv .slider-for').slick({
            dots: false,
            rtl: true,
            slidesToShow: 3,
            accessibility: false,
            draggable: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    }
    $('.slider-reps,.slider-adv').removeClass('d-none');
    // profile
    (function (root, factory) {
        if (typeof define === 'function' && define.amd) {
            define(['exports'], factory);
        } else if (typeof exports !== 'undefined') {
            factory(exports);
        } else {
            factory((root.dragscroll = {}));
        }
    }(this, function (exports) {
        var _window = window;
        var _document = document;
        var mousemove = 'mousemove';
        var mouseup = 'mouseup';
        var mousedown = 'mousedown';
        var EventListener = 'EventListener';
        var addEventListener = 'add'+EventListener;
        var removeEventListener = 'remove'+EventListener;
        var newScrollX, newScrollY;

        var dragged = [];
        var reset = function(i, el) {
            for (i = 0; i < dragged.length;) {
                el = dragged[i++];
                el = el.container || el;
                el[removeEventListener](mousedown, el.md, 0);
                _window[removeEventListener](mouseup, el.mu, 0);
                _window[removeEventListener](mousemove, el.mm, 0);
            }

            // cloning into array since HTMLCollection is updated dynamically
            dragged = [].slice.call(_document.getElementsByClassName('dragscroll'));
            for (i = 0; i < dragged.length;) {
                (function(el, lastClientX, lastClientY, pushed, scroller, cont){
                    (cont = el.container || el)[addEventListener](
                        mousedown,
                        cont.md = function(e) {
                            if (!el.hasAttribute('nochilddrag') ||
                                _document.elementFromPoint(
                                    e.pageX, e.pageY
                                ) == cont
                            ) {
                                pushed = 1;
                                lastClientX = e.clientX;
                                lastClientY = e.clientY;

                                e.preventDefault();
                            }
                        }, 0
                    );

                    _window[addEventListener](
                        mouseup, cont.mu = function() {pushed = 0;}, 0
                    );

                    _window[addEventListener](
                        mousemove,
                        cont.mm = function(e) {
                            if (pushed) {
                                (scroller = el.scroller||el).scrollLeft -=
                                    newScrollX = (- lastClientX + (lastClientX=e.clientX));
                                scroller.scrollTop -=
                                    newScrollY = (- lastClientY + (lastClientY=e.clientY));
                                if (el == _document.body) {
                                    (scroller = _document.documentElement).scrollLeft -= newScrollX;
                                    scroller.scrollTop -= newScrollY;
                                }
                            }
                        }, 0
                    );
                })(dragged[i++]);
            }
        }


        if (_document.readyState == 'complete') {
            reset();
        } else {
            _window[addEventListener]('load', reset, 0);
        }

        exports.reset = reset;
    }));
    let chatId,postId;
    let activeTab = $(".nav-tabs a[href$=\""+location.href.split('#')[1]+"\"]:first");
    if (activeTab.length) activeTab.tab('show');
    else $(".nav-tabs a:first").tab('show');
    $('.nav-tabs a').click(function (e) {
        e.preventDefault();
        $(this).tab('show');
    });
    $('.profile-page #contactUsModal form').submit(function (e) {
        e.preventDefault();
        $('<input>',{
            type : 'hidden',
            name : 'post_id',
            value : postId
        }).appendTo(this);
        $(this)[0].submit();
    });
    $('.profile-page .posts .post .card a.accept').click(function (e) {
        e.preventDefault();
        postId = $(this).parents('.post').attr('data-id');
        chatId = $(this).parents('.card').attr('data-chat-id');
        $('.profile-page #contactUsModal .modal-body .form-group').addClass('d-none');
        $('.profile-page #contactUsModal .modal-body .chat').removeClass('d-none');
        $('.profile-page #contactUsModal .modal-body .mobile').html($(this).parents('.post').find('input.mobile').val());
        $('.profile-page #contactUsModal').modal('show');
    });
    $('.profile-page .modal .chat').click(function () {
        if (chatId) {
            window.location.href = 'chat/'+postId + '/' +chatId;
            return false;
        }
        $(this).addClass('d-none');
        $(this).parents('.modal-body').find('.form-group').removeClass('d-none');
    });
    $('.profile-page .modal textarea').keyup(function () {
        let btnSend = $('.modal .btn-send');
        if ($(this).val().trim().length)
            btnSend.removeClass('d-none');
        else btnSend.addClass('d-none')
    });
    $('.profile-page .post-report .card-header').click(function () {
        $(this).find('i').toggleClass('chevron-up');
    });
    $('.profile-page .tab-pane .card').hover(function () {
        $(this).toggleClass('shadow shadow-sm');
    }, function () {
        $(this).toggleClass('shadow shadow-sm');
    });
    $('.profile-page input[name=layout]').change(() => {
        $('form#layout').submit();
    });
    $('.profile-page .list-group .list-group-item').each(function () {
        if (window.location.href === $(this).find('a').attr('href')) {
            $(this).css('background', '#eee');
        }
    })
    let spin = '<span class="spinner-border spinner-border-sm align-middle" role="status" aria-hidden="true"></span> ';
    $('.profile-page .card .btn-delete').click(function (e) {
        e.preventDefault();
        let _this = $(this);
        let tab = _this.parents('.tab-pane');
        let type = tab.attr('id');
        _this.html(spin);
        let id = _this.parents('.post').attr('data-id');
        let postId = _this.parents('.post').attr('data-post-id');
        let url;
        if (type === 'bookmarks') url = 'bookmarkPost/' + postId;
        else url = 'lastVisitedPost/' + id;
        $.post(url,{_method:'DELETE'},function (data) {
            if (data.error === false) {
                _this.parents('.post').remove();
                let count = tab.find('.posts').children().length;
                if (!count) tab.html('<div class="alert alert-warning">'+i18n.site.post_not_found+'</div>');
            }
        }).fail(function () {
            _this.html('<i class="fa fa-trash-o"></i>');
        });
    });
    // register_login
    let login = $('.register-login');
    let mobile;
    let loadingText = i18n.site.loading;
    let loginText = i18n.site.enter;
    let spinner = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ';
    login.on('click','button[name=send_code]',function (e) {
        let _this = $(this);
        mobile = login.find('input[name=mobile]').val();
        login.find('button[name=charities_login]').attr('disabled',true);
        toastr.remove();
        if (mobile.length === 0){
            toastr.warning(i18n.site.input_mobile_number);
            return false;
        } else if (mobile.length !== 11 || mobile.indexOf('09') === -1){
            toastr.warning(i18n.site.mistake_mobile_number);
            return false;
        }
        _this.html(loadingText).prepend(spinner).attr('disabled',true);
        $.post('/api/register',{mobile:mobile},function (data) {
            console.log(data)
            if (data.error){
                toastr.error(data.message);
                _this.html(i18n.site.get_code).attr('disabled',false);
                login.find('button[name=charities_login]').attr('disabled',false);
                return false;
            }
            requestCode();
            _this.html(loginText).attr('disabled',false);
            let code = i18n.site.input_verify_code;
            let tip = i18n.site.tip_verify_code.replace(':mobile',mobile);
            login.find('button[name=charities_login]').hide();
            login.find('label[for=mobile]').html(code);
            login.find('.tip').html(tip);
            login.find('input[name=mobile]').attr('placeholder','');
            login.find('input[name=mobile]').attr('name','code').val(null);
            login.find('button[name=send_code]').attr('name','verify_code');
        }).fail(function () {
            _this.html(i18n.site.get_code).attr('disabled',false);
            login.find('button[name=charities_login]').attr('disabled',false);
            toastr.error(i18n.site.server_error);
        });
    });
    login.on('click','button[name=request_code]',function (e) {
        let _this = $(this);
        _this.html(loadingText).prepend(spinner);
        $.post('/api/register',{mobile:mobile},function (data) {
            if (data.error){
                toastr.error(data.message);
                return false;
            }
            requestCode();
        });
    });
    login.on('click','button[name=verify_code]',function (e) {
        let _this = $(this);
        _this.html(loadingText).prepend(spinner).attr('disabled',true);
        login.find('button[name=users_login]').attr('disabled',true);
        toastr.remove();
        let code = login.find('input[name=code]').val();
        let data = {};
        data.verification_code = code;
        if (login.find('button[name=users_login]').is('button[name=users_login]')) data.role_id = 2;

        $.post('login',data,function (data) {
            if (data.error === false){
                localStorage.setItem('auth_token', data.data.accessToken);
                window.location.replace('home');
            }
        }).fail(function (xhr) {
            _this.html(loginText).attr('disabled',false);
            login.find('button[name=users_login]').attr('disabled',false);
            if (xhr.status === 401) {
                toastr.warning(i18n.site.mistake_verify_code);
            }else {
                toastr.error(i18n.site.server_error);
            }
        });
    });
    login.on('click','button[name=charities_login],button[name=users_login]',function () {
        let _this = $(this);
        login.fadeOut(500,function () {
            if (_this.attr('name') === 'charities_login') {
                charitiesComponent();
            }else usersComponent();
            login.fadeIn(1000);
        });
    });
    function charitiesComponent() {
        login.find('label[for=mobile]').attr('for','code').html(i18n.site.input_verify_code);
        login.find('input[name=mobile]').attr({name:'code',type:'text',placeholder:''}).val(null);
        login.find('button[name=send_code]').attr('name','verify_code').html(i18n.site.enter);
        login.find('button[name=charities_login]').attr('name','users_login').html(i18n.site.users_login);
        login.find('.tip').html(i18n.site.charities_tip);
    }
    function usersComponent() {
        login.find('label[for=code]').attr('for','mobile').html(i18n.site.input_mobile_number);
        login.find('input[name=code]').attr({name:'mobile',type:'number',placeholder:i18n.site.mobile_placeholder}).val(null);
        login.find('button[name=verify_code]').attr('name','send_code').html(i18n.site.get_code);
        login.find('button[name=users_login]').attr('name','charities_login').html(i18n.site.charities_login);
        login.find('.tip').html(i18n.site.mobile_number_tip);
    }
    function requestCode() {
        let request_code = $('button[name=request_code]');
        request_code.attr('disabled',true).removeClass('d-none');
        let second = 60;
        request_code.html(i18n.site.request_code_remind.replace(':remind',"(1:00)"));
        let interval = setInterval(function() {
            second--;
            request_code.html(i18n.site.request_code_remind.replace(':remind',"(00:" + second * 1000 / 1000+")"));
            if (second === 0){
                request_code.html(i18n.site.request_code).attr('disabled',false);
                clearInterval(interval)
            }
        }, 1000);
    }
    // show_post
    if ($.fn.slick) {
        $('.show-post .slider-for').slick({
            dots: true,
            rtl: true,
            customPaging: function (slider, i) {
                let thumb = $(slider.$slides[i]).data('thumb');
                let title = $(slider.$slides[i]).data('title');
                return '<a><img alt="' + title + '" src="' + thumb + '"></a>';
            },
        });
    }
    $('.show-post .post-report .card-header').click(function () {
        $(this).find('i').toggleClass('chevron-up');
        $(this).parent().find('.card-body').slideToggle();
    });
    $('.show-post .bookmark').click(function () {
        let _this = $(this);
        let id = _this.parents('.card').attr('data-id');
        let data = {post_id: id};
        if (_this.hasClass('active')) {
            data._method = 'DELETE';
            storeOrRemoveBookmark('/bookmarkPost/' + id, data, true);
        } else {
            storeOrRemoveBookmark('/bookmarkPost', data, false);
        }
    });
    $('.show-post form#notification button').click(function (e) {
        e.preventDefault();
        if ($(this).hasClass('accept')) {
            postId = $('.show-post .post').attr('data-id');
            chatId = $(this).attr('data-chat-id');
            $('.show-post #contactUsModal .modal-body .form-group').addClass('d-none');
            $('.show-post #contactUsModal .modal-body .chat').removeClass('d-none');
            $('.show-post #contactUsModal .modal-body .mobile').html($(this).attr('data-mobile'));
            $('.show-post #contactUsModal').modal('show');
        } else {
            let id = $(this).attr('id');
            let form = $('.show-post form#notification');
            let action = form.attr('action');
            action = action.substring(0, action.length - 1);
            form.attr('action', action + id);
            form.submit();
        }
    });
    $('.show-post .modal textarea').keyup(function () {
        let btnSend = $('.modal .btn-send');
        if ($(this).val().trim().length)
            btnSend.removeClass('d-none');
        else btnSend.addClass('d-none')
    });
    $('.show-post .modal .chat').click(function () {
        if (chatId) {
            window.location.href = 'chat/'+postId + '/' +chatId;
            return false;
        }
        $(this).addClass('d-none');
        $(this).parents('.modal-body').find('.form-group').removeClass('d-none');
    });
    $('.show-post .notification').click(function () {
        let _this = $(this);
        let id = _this.parents('.card').attr('data-id');
        let data = {post_id: id};
        if (_this.hasClass('active')) {
            data._method = 'DELETE';
            storeOrRemoveNotification('/notification/' + id, data, true);
        } else {
            storeOrRemoveNotification('/notification', data, false);
        }
    });

    function storeOrRemoveBookmark(url, data, isActive) {
        $.post(url, data, function (value) {
            if (value.error === false) {
                let bookmark = $('.show-post .bookmark');
                if (isActive) {
                    bookmark.html(i18n.site.bookmark)
                } else bookmark.html(i18n.site.bookmarked);
                bookmark.toggleClass('active');
            }
        });
    }

    function storeOrRemoveNotification(url, data, isActive) {
        $.post(url, data, function (value) {
            if (value.error === false) {
                let notification = $('.show-post .notification');
                if (isActive) {
                    notification.html(i18n.site.send_request)
                } else notification.html(i18n.site.delete_request);
                notification.toggleClass('active');
            }
        });
    }
    // add_or_edit_post
})